export default (() => {
    console.log('UNTUCKit : Module : Press : loaded');
    const loadArticles = (event) => {
        const target = event.currentTarget;
        if (!(target instanceof HTMLElement)) {
            return;
        }
        document.querySelectorAll('.js-press-block').forEach((article) => {
            article.classList.remove('is-disabled');
        });
        target.classList.add('is-disabled');
    };
    const init = () => {
        console.log('UNTUCKit : Module : Press : init');
        document.querySelectorAll('.js-press-load').forEach((button) => {
            button.addEventListener('click', loadArticles);
        });
    };
    return { init };
})();
